import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import { getAirports, getClassName, getPlaces, getRoutes } from "./functions";
import AppContext from "../../context/AppContext";
import { Map, TileLayer } from "react-leaflet";
import MapPlaces from "../MapPlaces";
import MapAirports from "../MapAirports";
import MapRoutes from "../MapRoutes";

class MapWrapper extends PureComponent {
  static contextType = AppContext;

  render() {
    const { isMenuShown, places, airports, routes } = this.context;
    const visiblePlaces = getPlaces(places);
    const visibleAirports = getAirports(airports);
    const visibleRoutes = getRoutes(routes);
    return (
      <section className={getClassName(isMenuShown)}>
        <section className="Map_container">
          <Map
            center={[51, 17]}
            zoom={4}
            className="Map"
            maxBounds={[[-90, -180], [90, 180]]}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution="&copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a>"
            />
            <MapPlaces places={visiblePlaces} />
            <MapAirports airports={visibleAirports} />
            <MapRoutes routes={visibleRoutes} airports={airports} />
          </Map>
        </section>
      </section>
    );
  }
}

export default MapWrapper;
